import List from './List';
import ListItemLink from './ListItemLink';
import Title from './ListTitle';
import Section from './Section';

type LinksSectionProps = {
  title: string;
  items: {
    href: string;
    dataTestId: string;
    label: string;
    isExternal?: boolean;
  }[];
};

export default function LinksSection({ title, items }: LinksSectionProps) {
  return (
    <Section>
      <Title>{title}</Title>
      <List>
        {items.map((item) => (
          <ListItemLink
            key={item.dataTestId}
            href={item.href}
            dataTestId={item.dataTestId}
            isExternal={item.isExternal}
          >
            {item.label}
          </ListItemLink>
        ))}
      </List>
    </Section>
  );
}
